import { Component, OnInit } from '@angular/core';
// import { StateService } from '@uirouter/angular';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './../../../services/auth.service';
import { UserService } from './../../../services/user.service';
import { CommonFunctionService } from './../../../services/common-function.service';

import { AppSettings } from './../../../app.settings';
import { ElasticsearchService } from 'app/services/elasticsearch.service';

import { v1 as uuid } from 'uuid';
import { AdminService } from 'app/services/admin.service';
import { LayerService } from 'app/services/layer.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	public email: string;
	public password: string;
	public imgUrl: string = AppSettings.authLogoUrl;
	public registerUrl = AppSettings.lbRegisterUrl;
	public pwResetUrl = AppSettings.lbPwResetUrl;
	public isLoggingin = false;
	constructor(
		private router: Router,
		private toastr: ToastrService,
		private adminService: AdminService,
		private authService: AuthService,
		private userService: UserService,
		private commonFuncService: CommonFunctionService,
		private layerService: LayerService
		// private esService: ElasticsearchService
	) { }

	login() {
		if (!this.password) {
			this.toastr.error('Please enter a password.');
			return;
		}
		// Test: es
			// this.esService.addToIndex({
			// 	index: 'index',
			// 	type: 'login',
			// 	id: uuid(),
			// 	body: {
			// 		test: 123
			// 	}
			// }).then(res => {
			// 	console.log('added success', res);
			// }, err => {
			// 	console.log('err', err);
			// });
		//
		this.commonFuncService.setLoadingSpinner(true);
		this.authService.login(this.email, this.password,
			async (res) => {
				try {
					// update token
					await this.userService.setUpdatedToken(res.data.content);
					// const usbList = await this.adminService.getUserSubscription(this.email, 'A3I');
					// if (usbList && usbList[0] ) {
					// 	await this.userService.generateApiKey(this.password, usbList[0].userSubId);
					// }
					await this.userService.generateApiKey(this.password, this.userService.getUserInfo().userSubId);
					// // Get previous state path
					// const prevStateInfo = sessionStorage.getItem('prevState') ? JSON.parse(sessionStorage.getItem('prevState')) : null;
					// // Default path '/azgiv'
					// const path = (prevStateInfo && prevStateInfo.path) ? prevStateInfo.path : '/azgiv';
					// // const params = (prevStateInfo && prevStateInfo.params) ? prevStateInfo.params : {};
					// this.router.navigateByUrl(path);

					try {
						await this.layerService.getLayers();
					} catch (err) {

					}
					const layers = this.layerService.layerListBS.getValue();
					const url = (layers.layers && layers.layers.find(l => l.id)) ? '/azgiv/layers/live-layers' : '/azgiv/dashboard';
					this.router.navigateByUrl(url, {
						queryParamsHandling: 'preserve'
					}).then(() => {

					});
				} catch (err) {
					console.log(err);
				}
				//
				this.isLoggingin = false;
				this.commonFuncService.setLoadingSpinner(false);
			}, (err) => {
				this.isLoggingin = false;
				this.commonFuncService.setLoadingSpinner(false);
			});
	}

	test() {
		this.authService.test();
	}

	// login() {
	// 	this.commonFuncService.setLoadingSpinner(true);
	// 	this.authService.login(this.email, // sarah.hess@gisticinc.com
	// 		(res) => {
	// 			// update token
	// 			this.userService.setUpdatedToken(res.data.content);
	// 			// check user subscription
	// 			this.adminService.getUserSubscription(this.email,
	// 				(rsp) => {
	// 					this.isLoggingin = false;
	// 					this.commonFuncService.setLoadingSpinner(false);
	// 					// user has subscription. allow loging in.
	// 					if (rsp.data && rsp.data[0]) {
	// 						this.userService.setHasUserSubscription(true);
	// 						// Get previous state path
	// 						const prevStateInfo = sessionStorage.getItem('prevState') ? JSON.parse(sessionStorage.getItem('prevState')) : null;
	// 						// Default path '/azgiv'
	// 						const path = prevStateInfo ? prevStateInfo.path : '/azgiv';
	// 						const params = prevStateInfo ? prevStateInfo.params : {};
	// 						this.router.navigate([path, params]);
	// 						// const toState = prevStateInfo ? prevStateInfo.name : 'azgiv';
	// 						// const params = prevStateInfo ? prevStateInfo.params : {};
	// 						// this.stateService.go(toState, params).then(() => {

	// 						// });
	// 					} else { // user has not subscription.
	// 						this.userService.setHasUserSubscription(false);
	// 						console.log('NO USER SUBSCRIPTION.');
	// 						this.toastr.error('No user subscription.');
	// 					}
	// 				}, (err) => {
	// 					this.isLoggingin = false;
	// 					this.commonFuncService.setLoadingSpinner(false);
	// 				});
	// 		}, (err) => {
	// 			this.isLoggingin = false;
	// 			this.commonFuncService.setLoadingSpinner(false);
	// 		});
	// }
	ngOnInit() {
	}

}
